import { render } from "./PhysicalStoreSection.vue?vue&type=template&id=2b55b6ba&scoped=true"
import script from "./PhysicalStoreSection.vue?vue&type=script&lang=js"
export * from "./PhysicalStoreSection.vue?vue&type=script&lang=js"

import "./PhysicalStoreSection.vue?vue&type=style&index=0&id=2b55b6ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b55b6ba"]])

export default __exports__